export default "__VITE_ASSET__b1ea2e78__"